module.exports = __webpack_public_path__ + "img/nav-design-growing.6f79246.jpg";